import { Component, Input, Output, EventEmitter } from '@angular/core';
import { EmailRecipient } from '../../modals/email-send-modal/models/email-recipient.interface';

@Component({
    selector: 'app-email-chip',
    templateUrl: './email-chip.component.html',
    styleUrls: ['./email-chip.component.scss']
})
export class EmailChipComponent {
    @Input() recipient: EmailRecipient;
    @Output() remove = new EventEmitter<string>();
    @Input() removable: boolean = true;
    @Input() isSearchResult: boolean = false;

    public onRemove(): void {
        this.remove.emit(this.recipient.id);
    }
}
